import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as dom from '../dom.js';
import { StandardKeyboardEvent } from '../keyboardEvent.js';
import { StandardMouseEvent } from '../mouseEvent.js';
import { Disposable } from '../../common/lifecycle.js';
import { Gesture } from '../touch.js';
export var Widget = /*#__PURE__*/function (_Disposable) {
  _inherits(Widget, _Disposable);

  var _super = _createSuper(Widget);

  function Widget() {
    _classCallCheck(this, Widget);

    return _super.apply(this, arguments);
  }

  _createClass(Widget, [{
    key: "onclick",
    value: function onclick(domNode, listener) {
      this._register(dom.addDisposableListener(domNode, dom.EventType.CLICK, function (e) {
        return listener(new StandardMouseEvent(e));
      }));
    }
  }, {
    key: "onmousedown",
    value: function onmousedown(domNode, listener) {
      this._register(dom.addDisposableListener(domNode, dom.EventType.MOUSE_DOWN, function (e) {
        return listener(new StandardMouseEvent(e));
      }));
    }
  }, {
    key: "onmouseover",
    value: function onmouseover(domNode, listener) {
      this._register(dom.addDisposableListener(domNode, dom.EventType.MOUSE_OVER, function (e) {
        return listener(new StandardMouseEvent(e));
      }));
    }
  }, {
    key: "onnonbubblingmouseout",
    value: function onnonbubblingmouseout(domNode, listener) {
      this._register(dom.addDisposableNonBubblingMouseOutListener(domNode, function (e) {
        return listener(new StandardMouseEvent(e));
      }));
    }
  }, {
    key: "onkeydown",
    value: function onkeydown(domNode, listener) {
      this._register(dom.addDisposableListener(domNode, dom.EventType.KEY_DOWN, function (e) {
        return listener(new StandardKeyboardEvent(e));
      }));
    }
  }, {
    key: "onkeyup",
    value: function onkeyup(domNode, listener) {
      this._register(dom.addDisposableListener(domNode, dom.EventType.KEY_UP, function (e) {
        return listener(new StandardKeyboardEvent(e));
      }));
    }
  }, {
    key: "oninput",
    value: function oninput(domNode, listener) {
      this._register(dom.addDisposableListener(domNode, dom.EventType.INPUT, listener));
    }
  }, {
    key: "onblur",
    value: function onblur(domNode, listener) {
      this._register(dom.addDisposableListener(domNode, dom.EventType.BLUR, listener));
    }
  }, {
    key: "onfocus",
    value: function onfocus(domNode, listener) {
      this._register(dom.addDisposableListener(domNode, dom.EventType.FOCUS, listener));
    }
  }, {
    key: "ignoreGesture",
    value: function ignoreGesture(domNode) {
      Gesture.ignoreTarget(domNode);
    }
  }]);

  return Widget;
}(Disposable);